import { createContext, type ReactNode, useMemo } from 'react'
import type { IconContainerProps } from './IconContainer.tsx'

export type IconContainerOptionsContextValue = Pick<
  IconContainerProps,
  'size' | 'context' | 'withInnerPadding'
>

/**
 * This is intentionally default to `{}` instead of `undefined`.
 * We don't throw an error in the use context hook because it should be optional to use.
 */
// eslint-disable-next-line react-refresh/only-export-components
export const IconContainerOptionsContext =
  createContext<IconContainerOptionsContextValue>({})

export interface IconContainerOptionsProviderProps
  extends IconContainerOptionsContextValue {
  children?: ReactNode
}

export const IconContainerOptionsProvider = (
  props: IconContainerOptionsProviderProps,
) => {
  const { children, ...contextProps } = props

  const contextValue = useMemo(
    () => contextProps,
    // We create the dependency array from the values of the context props dynamically,
    // so we don't have to map the prop one by one.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(contextProps),
  )

  return (
    <IconContainerOptionsContext.Provider value={contextValue}>
      {children}
    </IconContainerOptionsContext.Provider>
  )
}
